"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalitaCertificazioneTypeToJSON = exports.ModalitaCertificazioneTypeFromJSONTyped = exports.ModalitaCertificazioneTypeFromJSON = exports.ModalitaCertificazioneType = void 0;
/**
 *
 *
 * 1 = Sincrona
 *
 * 2 = Asincrona
 * @export
 * @enum {string}
 */
var ModalitaCertificazioneType;
(function (ModalitaCertificazioneType) {
    ModalitaCertificazioneType[ModalitaCertificazioneType["NUMBER_1"] = 1] = "NUMBER_1";
    ModalitaCertificazioneType[ModalitaCertificazioneType["NUMBER_2"] = 2] = "NUMBER_2";
})(ModalitaCertificazioneType = exports.ModalitaCertificazioneType || (exports.ModalitaCertificazioneType = {}));
function ModalitaCertificazioneTypeFromJSON(json) {
    return ModalitaCertificazioneTypeFromJSONTyped(json, false);
}
exports.ModalitaCertificazioneTypeFromJSON = ModalitaCertificazioneTypeFromJSON;
function ModalitaCertificazioneTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ModalitaCertificazioneTypeFromJSONTyped = ModalitaCertificazioneTypeFromJSONTyped;
function ModalitaCertificazioneTypeToJSON(value) {
    return value;
}
exports.ModalitaCertificazioneTypeToJSON = ModalitaCertificazioneTypeToJSON;
